module.exports = require("./zh-Hant-MO");